import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.413 16.314a4 4 0 0 1-1.032-.14 13.72 13.72 0 0 1-9.555-9.548 3.86 3.86 0 0 1 .447-3.082 4 4 0 0 1 2.616-1.82 1.69 1.69 0 0 1 1.797.792l1.172 1.98a2.1 2.1 0 0 1-.644 2.82l-.849.564a8.2 8.2 0 0 0 3.747 3.756l.572-.852a2.1 2.1 0 0 1 2.822-.636l1.982 1.182c.614.366.931 1.083.792 1.782a4 4 0 0 1-1.82 2.615 3.9 3.9 0 0 1-2.047.587M5.233 2.813a.5.5 0 0 0-.11.01 2.88 2.88 0 0 0-1.891 1.311 2.75 2.75 0 0 0-.32 2.193 12.58 12.58 0 0 0 8.766 8.762c.747.204 1.524.09 2.191-.32a2.88 2.88 0 0 0 1.307-1.88.565.565 0 0 0-.264-.594l-1.982-1.182a.98.98 0 0 0-1.312.295l-.836 1.25a.56.56 0 0 1-.684.205 9.3 9.3 0 0 1-4.96-4.972.56.56 0 0 1 .207-.685l1.246-.829A.974.974 0 0 0 6.89 5.07l-1.173-1.98a.56.56 0 0 0-.484-.276"
    }, null, -1)
  ])))
}
export default { render: render }